export const company =
{
    name: 'RE/MAX Top Properties',
    welcomeName: 'RE/MAX Top Properties',
    mainServiceArea: 'Phuket',
    navPhone: '+66 93 642 9991',
    phone1: '+66 93 642 9991',
    email: 'topproperties@remax.co.th',
    address1: '191/4 Nanai Rd, Patong',
    address2: 'Phuket, Thailand',
    phoneUrl: 'tel:66936429991',
    whatsappUrl: 'https://wa.me/66936429991',
    lineUrl: '',
    // whatsappUrl: '',
    youtubeUrl: '',
    facebookUrl: 'https://www.facebook.com/remaxtoppropertiesinphuket',
    instagramUrl: '',
    tiktokUrl: '',
    linkedInUrl: ''
}
